// public/js/features/pois/poi-cache.js
// localStorage-backed POI cache + persisted filter (which types are on).
//
// Goal: stop re-hitting the backend on every map visit. The POI bundle is
// served from storage and refreshed in the BACKGROUND once it is older than
// POI_REVALIDATE_MS; the user's last filter selection is restored so disabled
// types are never rendered.
const CACHE_KEY = 'poi.cache.v1';
const ENABLED_KEY = 'poi.enabled.v1';
export const POI_TTL_MS = 24 * 60 * 60 * 1000; // 24h - hard limit: block and fetch
// After this, the cache is still SERVED but refreshed in the background
// (stale-while-revalidate). A 24h-only cache meant a POI TYPE created by a
// colleague stayed invisible to everyone else for up to a day - they could not
// pick it for a POI and could not switch it on on the map. Types are a handful
// of rows and they matter immediately, so waiting a day is not an option; a
// blocking fetch on every map visit is what the cache exists to avoid.
export const POI_REVALIDATE_MS = 10 * 60 * 1000; // 10 min

// → { types, pois, ts, fresh } or null when nothing is cached.
export function readPoiCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || typeof obj.ts !== 'number') return null;
    return {
      types: Array.isArray(obj.types) ? obj.types : [],
      pois: Array.isArray(obj.pois) ? obj.pois : [],
      ts: obj.ts,
      fresh: Date.now() - obj.ts < POI_TTL_MS,
      stale: Date.now() - obj.ts > POI_REVALIDATE_MS,
    };
  } catch {
    return null;
  }
}

export function writePoiCache(types = [], pois = []) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), types, pois }));
  } catch (e) {
    console.warn('[poi-cache] write failed', e);
  }
}

// Persisted filter selection. null = the user has no saved preference yet.
export function readEnabledTypes() {
  try {
    const raw = localStorage.getItem(ENABLED_KEY);
    if (raw == null) return null;
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : null;
  } catch {
    return null;
  }
}

export function writeEnabledTypes(ids = []) {
  try {
    localStorage.setItem(ENABLED_KEY, JSON.stringify([...ids]));
  } catch (e) {
    console.warn('[poi-cache] enabled write failed', e);
  }
}
